/* OverDMA — Ficha de producto
   Descripción plegable: sin JS se ve completa. Si mide más que el límite se
   recorta y aparece "Mostrar más / Mostrar menos" (textos del locale del tema,
   pasados desde el bloque custom-liquid de templates/product.json). */
(function () {
  var LIMIT = 560;
  var cfg = window.overdmaProduct || {};
  var more = cfg.showMore || 'Show more';
  var less = cfg.showLess || 'Show less';

  var descriptionId = 0;
  function init(root) {
    root.querySelectorAll('.product__description:not([data-odma-desc])').forEach(function (body, i) {
      body.setAttribute('data-odma-desc', '');
      if (body.scrollHeight <= LIMIT * 1.25) return;
      if (!body.id) {
        do { descriptionId += 1; body.id = 'OdmaDesc-' + descriptionId; }
        while (document.querySelectorAll('[id="' + body.id + '"]').length > 1);
      }
      var btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 'odma-desc__toggle';
      btn.setAttribute('aria-controls', body.id);
      btn.setAttribute('aria-expanded', 'false');
      btn.textContent = more;
      body.classList.add('odma-desc', 'is-collapsed');
      body.insertAdjacentElement('afterend', btn);
      body.addEventListener('focusin', function () {
        if (!body.classList.contains('is-collapsed')) return;
        body.classList.remove('is-collapsed');
        btn.setAttribute('aria-expanded', 'true');
        btn.textContent = less;
      });
      btn.addEventListener('click', function () {
        var collapsed = body.classList.toggle('is-collapsed');
        btn.setAttribute('aria-expanded', collapsed ? 'false' : 'true');
        btn.textContent = collapsed ? more : less;
        if (collapsed) body.scrollIntoView({ block: 'nearest' });
      });
    });
  }

  document.addEventListener('shopify:section:load', function (event) { init(event.target); });
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(document); });
  } else {
    init(document);
  }
})();
